module.exports = __webpack_public_path__ + "../resources/img/ic_error.3a057d58.svg";